/**
 * URL de base de l'API Assistant Netikash (backend Python).
 * En dev : backend sur port 8001. En prod : remplacer par l'URL déployée.
 */
export const ASSISTANT_API_BASE =
  process.env.REACT_APP_ASSISTANT_API_URL || 'http://localhost:8001';

export const ASSISTANT_API_PREFIX = '/api/v1';

// Feature flag: upload image pour diagnostic visuel (désactivé par défaut).
export const ASSISTANT_IMAGE_UPLOAD_ENABLED =
  process.env.REACT_APP_ASSISTANT_IMAGE_UPLOAD_ENABLED === 'true';

// Phase 2 pro: multi-images (reste derrière feature flag principale).
export const ASSISTANT_MULTI_IMAGE_UPLOAD_ENABLED =
  process.env.REACT_APP_ASSISTANT_MULTI_IMAGE_UPLOAD_ENABLED === 'true';

export const ASSISTANT_MAX_IMAGE_UPLOAD_COUNT = 4;
